// src/components/layout/BottomNav.js
// Barre de navigation fixe en bas - onglet "Récents" remplace "Voyages" - NE PAS MODIFIER

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import ROUTES from '../../constants/routes';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { theme } = useTheme();

  const tabs = [
    { icon: '🏠', label: t('nav.explorer'), path: ROUTES.HOME },
    { icon: '❤️', label: t('nav.favorites'), path: ROUTES.FAVORITES },
    { icon: '👀', label: t('nav.recent'), path: ROUTES.RESERVATIONS },
    { icon: '💬', label: t('nav.messages'), path: ROUTES.MESSAGES },
    { icon: '👤', label: t('nav.profile'), path: ROUTES.PROFILE },
  ];

  const isActive = (path) => {
    if (path === ROUTES.HOME) return location.pathname === ROUTES.HOME;
    return location.pathname.startsWith(path);
  };

  const styles = {
    nav: {
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '480px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: '8px 4px calc(8px + env(safe-area-inset-bottom, 0px))',
      backgroundColor: theme.navBg,
      borderTop: `1px solid ${theme.borderSoft}`,
      zIndex: 100,
    },
    tab: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '2px',
      padding: '4px 8px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      minWidth: '48px',
      minHeight: '48px',
    },
    icon: { fontSize: '20px', opacity: 1 },
    iconInactive: { opacity: 0.5 },
    label: { fontSize: '10px', fontWeight: '600', color: theme.textMuted },
    labelActive: { color: theme.gold },
  };

  return (
    <nav style={styles.nav}>
      {tabs.map((tab) => {
        const active = isActive(tab.path);
        return (
          <button key={tab.path} style={styles.tab} onClick={() => navigate(tab.path)}>
            <span style={{ ...styles.icon, ...(active ? {} : styles.iconInactive) }}>{tab.icon}</span>
            <span style={{ ...styles.label, ...(active ? styles.labelActive : {}) }}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;